import {SetStateAction} from 'react';
import DialogComponent from '$components/DialogComponent';
import CancelAppointmentComponent from './component';

interface CancelAppointmentContainerProps {
  cancelAppointmentModal: boolean;
  setCancelAppointmentModal: React.Dispatch<SetStateAction<boolean>>;
  payment_id?: number;
  payment_status?: string;
}

const CancelAppointmentContainer: React.FC<CancelAppointmentContainerProps> = ({
  cancelAppointmentModal,
  setCancelAppointmentModal,
  payment_id,
  payment_status,
}) => {
  return (
    <DialogComponent
      open={cancelAppointmentModal}
      handleClose={setCancelAppointmentModal}
      dialogBody={
        <CancelAppointmentComponent
          cancelAppointmentModal={cancelAppointmentModal}
          setCancelAppointmentModal={setCancelAppointmentModal}
          paymentId={payment_id}
          paymentStatus={payment_status}
        />
      }
    />
  );
};

export default CancelAppointmentContainer;
